export default __webpack_public_path__ + "f9e562bb3d05ac234b7ce5fbbc4ed6d9.svg";